/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgZorroAntdModule, NZ_I18N, en_US } from 'ng-zorro-antd';

import { JwtInterceptor } from './@theme/components/auth/jwt.interceptor';

import { CompanyService } from './@core/data/company.service';
import { GrafanaService } from './@core/data/grafana.service';
import { UserService } from './@core/data/user.service';
import { AuthGuardService } from './@core/data/auth-guard.service';
import { AnosService } from './@core/data/anos.service';
import { MembershipService } from './@core/data/membership.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,

    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    NgZorroAntdModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    CompanyService,
    GrafanaService,
    MembershipService,
    AnosService,
    UserService,
    { provide: APP_BASE_HREF, useValue: '/' },
    AuthGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: NZ_I18N, useValue: en_US },
  ],
})
export class AppModule {}
